// Archaeology (M22-adjacent). PURE (ENG-1). Brushing a suspicious block advances it
// through a few dusting stages; the last brush reveals its buried find (rolled from
// the block's loot table) and collapses it into plain sand/gravel.
import { ARCHAEOLOGY } from '../config';

/** Advance the brush stage on a suspicious block, clamped at the reveal stage. */
export function brushProgress(prev: number): number {
  return Math.min(ARCHAEOLOGY.BRUSH_STAGES, prev + 1);
}

/** The block reveals its find once fully brushed. */
export function brushComplete(progress: number): boolean {
  return progress >= ARCHAEOLOGY.BRUSH_STAGES;
}

/** Total brush stages before a reveal. */
export function brushStages(): number {
  return ARCHAEOLOGY.BRUSH_STAGES;
}

const SUSPICIOUS_BASE: Record<string, string> = { suspicious_sand: 'sand', suspicious_gravel: 'gravel' };

/** The plain block a brushed-out suspicious block collapses into, or null. */
export function suspiciousBase(block: string): string | null {
  return SUSPICIOUS_BASE[block] ?? null;
}

/** Whether a block is a brushable suspicious block. */
export function isSuspicious(block: string): boolean {
  return block in SUSPICIOUS_BASE;
}

/** The loot table a suspicious block is dug from (`archaeology/<block>`), or null. */
export function suspiciousLoot(block: string): string | null {
  return isSuspicious(block) ? `archaeology/${block}` : null;
}
